import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import calisthenics18Png from '@/assets/landing-activity-male/calisthenics-18.png'
import calisthenics30Png from '@/assets/landing-activity-male/calisthenics-30.png'
import calisthenics40Png from '@/assets/landing-activity-male/calisthenics-40.png'
import calisthenics50Png from '@/assets/landing-activity-male/calisthenics-50.png'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: '28-DAY MILITARY workout plan',
			uppercase: true,
			size: 'large',
			customStyles: {
				marginLeft: '1rem',
				marginRight: '1rem',
			},
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `${$t('female_activity.pages.landing.step_1.age')}`,
			}),
		}),

		LandingAgeGrid: (): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'green',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-29',
					label: 'Age: 18-29',
					img: calisthenics18Png,
				},
				{
					value: 30,
					analyticValue: '30-39',
					label: 'Age: 30-39',
					img: calisthenics30Png,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: 'Age: 40-49',
					img: calisthenics40Png,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: 'Age: 50+',
					img: calisthenics50Png,
				},
			],
		}),
	},
}

export default schema
